import GeneralDataMediaContainer from './GeneralDataMediaContainer';

export default GeneralDataMediaContainer;
